import React from 'react';
import {FieldArray} from 'formik';
import SurveyEditorFieldsType from './SurveyEditorFieldsType';

const SurveyExtraFieldsForm = () => {
    return (
        <div className="form-group">
            <FieldArray name="extraFields" component={SurveyEditorFieldsType} />
        </div>
    );
};

export default SurveyExtraFieldsForm;
